const screens = ['sm', 'md', 'lg', 'xl', '2xl']
type Screens = 'sm' | 'md' | 'lg' | 'xl' | '2xl'

export function compareScreen(value: Screens, op: '>=', other: Screens) {
  return screens.indexOf(value) >= screens.indexOf(other)
}
